import { sortedIndexBy } from "lodash";
import React, { useEffect, useState } from "react";
import { Message, Segment } from "semantic-ui-react";
import { useRecoilValue, selectorFamily } from "recoil";

import { loadLyrics } from "./api";
import { lyricsActive } from "./atoms";
import { playingTrack } from "./Sequencer";
import { isPositionAfterTiming } from "./utils";

const emptySong = (title) => {
  return {
    title: title,
    timings: [],
    lyrics: [],
  };
};

export const songsLyrics = selectorFamily({
  key: "songsLyrics",
  get: (title) => async ({ get }) => {
    if (!title) return emptySong(title);

    const lyrics = await loadLyrics(title);

    return lyrics ? lyrics : emptySong(title);
  },
});

export function LyricVerse({ title }) {
  const song = useRecoilValue(songsLyrics(title));
  const current = useRecoilValue(playingTrack);

  const [verse, setVerse] = useState("-");
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    const positionChange = ({ detail: { position } }) => {
      const i = sortedIndexBy(song.timings, [position], (e) => e[0]);

      let timing = song.timings[i];

      if (timing && timing[1] !== null) {
        if (isPositionAfterTiming(position, timing[0])) {
          setIndex(i);
          setVerse(timing[1] ? song.lyrics[timing[1] - 1] : "-");

          return;
        }
      } else {
        timing = song.timings[i - 1];

        if (timing && timing[1] !== null) {
          if (isPositionAfterTiming(position, timing[0])) {
            setIndex(i - 1);
            setVerse(timing[1] ? song.lyrics[timing[1] - 1] : "-");

            return;
          }
        }
      }

      setIndex(-1);
      setVerse("-");
    };

    document.addEventListener("sequencer:position", positionChange);

    return () => {
      document.removeEventListener("sequencer:position", positionChange);
    };
  }, [current.title, current.url, song, index]);

  return (
    <p style={verse === "-" ? { color: "#1b1c1d" } : { textAlign: "center" }}>
      {verse}
    </p>
  );
}

export function LyricsSubtitle() {
  const showLyrics = useRecoilValue(lyricsActive);
  const current = useRecoilValue(playingTrack);

  return showLyrics ? (
    <Segment className="lyrics">
      <Message size="huge" color="black">
        <React.Suspense fallback={null}>
          <LyricVerse title={current.title} />
        </React.Suspense>
      </Message>
    </Segment>
  ) : null;
}
